import { createInstance, dateReviver } from '@/api';
import { ProductSpecificationClient, ProductSpecification } from '@/api/frontoffice/clients';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';
import { i18n } from '@/i18n';

export interface ProductSpecificationStore {
    loading: boolean;
    specifications: ProductSpecification[];
}

export const client = new ProductSpecificationClient('', createInstance(), dateReviver);

export const useProductSpecificationStore = defineStore('products-product-specification-store', {
    state: (): ProductSpecificationStore => ({
        loading: false,
        specifications: null
    }),
    getters: {},
    actions: {
        async getProductsForDelivery(definitionId: string): Promise<void> {
            this.loading = true;
            this.specifications = null;
            useAlertStore().clearAlert();
            try {
                const response = await client.getProductsForDelivery(parseInt(definitionId));
                this.specifications = response;
            } catch (error) {
                useAlertStore().handleException(i18n.global.t('productSpecifications.detail.error.title'), error);
            } finally {
                this.loading = false;
            }
        },
        clear() {
            this.specifications = null;
            this.loading = false;
            useAlertStore().clearAlert();
        }
    }
});
